import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

 const GetDynamicRequest=(data:any)=>request({
  url: ApiURL.Query.GetRequest,
  method: RequestType.POST,
  data
 });
 const DynamicRequestQuery = {
  GetDynamicRequest,  
};

export default DynamicRequestQuery;